import React from "react";
import { Link } from "react-router-dom";

import "../scss/service.scss";

function Service() {
  return (
    <div className="service">
      <nav>
        <ul>
          <li><Link to="/portfolio/원페이지형"><img src="/image/subPage/서비스안내/typeIcon01.png" alt="" />원페이지형</Link></li>
          <li><Link to="/portfolio/표준형"><img src="/image/subPage/서비스안내/typeIcon02.png" alt="" />표준형</Link></li>
          <li><Link to="/portfolio/심화개발형"><img src="/image/subPage/서비스안내/typeIcon03.png" alt="" />심화개발형</Link></li>
          <li><Link to="/portfolio/쇼핑몰"><img src="/image/subPage/서비스안내/typeIcon04.png" alt="" />쇼핑몰</Link></li>
        </ul>
      </nav>

      <div className="wrap">
        <div className="content">
          <ul>
            <li>
              <div>
                <h2><b>원페이지형</b> 홈페이지</h2>
                <div></div>

                <p><b>스크롤을 내려, 끝까지 한번에 열람할 수 있는 형태</b></p>

                <p>
                  도입, 중간, 연락처 수집의 구성으로 나뉘어 집니다. 도입부에서는 소비자는 3초 후 떠난다는 가정하에, 1-3개의 문장에서 소비자의 관심을 촉발시키는 작용을 합니다. 한개의 문장에서 소비자로 하여금 해당 홈페이지에 좀 더 머물기를 작정한 소비자로 하여금 두번째, 세번째 단락에서 왜 연락을 취해야하는지에 대한 당위성을 논리있는 카피라이트와 이미지로 쉽게 설명합니다. 마지막 연락수집에서 해당 페이지를 본 사람의 니즈와 연락처를 기입하게하여, 홈페이지 존재의 목적을 달성하게 합니다.
                </p>

                <Link to="/portfolio/원페이지형">포트폴리오 보러가기 <i class="fa-solid fa-arrow-right-long"></i></Link>
              </div>
              <img src="/image/subPage/서비스안내/type01.png" alt="" />
            </li>

            <li>
              <div>
                <h2><b>표준형</b> 홈페이지</h2>
                <div></div>
              
                <p><b>원페이지형보다는 보다 일반적인 형태</b></p>

                <p>
                 회사의 소개, 연혁, 사업영역, 각 사업의 특성 및 견적, 포트폴리오 등을 여러 페이지에 담아 설명할 수 있습니다. 각각의 페이지를 소비자의 열람을 유도하여, 고객사의 전체적인 개요를 홈페이지를 방문함으로써 알 수 있습니다.  지금 당장 멋진 사옥을 건설할 수 없을지라도, 표준형 홈페이지를 웹상에 업로드함으로써, 전 세계 어디서든 고객사의 회사를 불특정 다수의 사람들에게 보여줄 수 있습니다.
                </p>

                <Link to="/portfolio/표준형">포트폴리오 보러가기 <i class="fa-solid fa-arrow-right-long"></i></Link>
              </div>
              <img src="/image/subPage/서비스안내/type02.png" alt="" />
            </li>

            <li>
              <div>
                <h2><b>심화개발형</b> 홈페이지</h2>
                <div></div>

                <p><b>표준형 홈페이지에서 웹프로그램을 추가한 형태</b></p>

                <p>
                  표준형 홈페이지에서 약간의 웹프로그램을 추가하면 단순 반복적인 업무를 자동화하여 보다 간편하게 처리할 수 있습니다. 또한, 홈페이지 안에 축적된 자료들을 일반 소비자로 하여금, 보다 효율적으로 찾고, 나열하여, 소비자의 최종 구매를 일으키는 확률을 보다 높일 수도 있습니다. 잠시 잠깐 스쳐가는 잠재적인 소비자들도 한번의 문의로 그 연락처를 획득하여, 향후 광고의 방향에 활용할수도 있습니다. 잘 만든 홈페이지 하나는 많은 경영비용을 줄일 수 있습니다.
                </p>

                <Link to="/portfolio/심화개발형">포트폴리오 보러가기 <i class="fa-solid fa-arrow-right-long"></i></Link>
              </div>
              <img src="/image/subPage/서비스안내/type03.png" alt="" />
            </li>

            <li>
              <div>
                <h2><b>쇼핑몰</b> 홈페이지</h2>
                <div></div>

                <p><b>제품을 판매하기 위한 결제기능이 있는 홈페이지</b></p>

                <p>
                  코랜에 쇼핑몰 제작을 맡겨주신다면, 쇼핑몰의 브랜드네이밍, 상표출원 컨설팅, 상세페이지 기획 및 제작, 광고의 방향설정 및 대행, 판매대행까지 그 방법론적인 부분을 성공사례와 함께 들으실 수 있으십니다. 경쟁사에 비해서 비교우위가 무엇이고 어떻게 접근해야하는지, 가격은 어떻게 설정하고, 각 오픈마켓에서의 대응전략은 무엇인지, 함께 연구할 수 있습니다. 쇼핑몰은 사진이 우수해야하고, 상세페이지는 기획을 잘해야합니다. 함께 성장하고자 하시는 고객사의 연락을 환영합니다.
                </p>

                <Link to="/portfolio/쇼핑몰">포트폴리오 보러가기 <i class="fa-solid fa-arrow-right-long"></i></Link>
              </div>
              <img src="/image/subPage/서비스안내/type04.png" alt="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Service;